/*Add oppr,proj,acct,extr,cmpt,team  Nov 18, 2023 */
/*Amend use m_inputTime for Time input Aug 8, 2024 */
/* Add kt-com-fld for tel Aug 24, 2024 */
/* Add multi Select Dec 14, 2024 */
/* Add  readonly and required columns Feb 1, 2025 */
/* Add required indicator Feb 15, 2025 */
/* Add requiredColumns Bug Fix  Apr 5, 2025 */
/* Add Percentage type  Apr 31, 2025 */
/* GUI changes Phase 1 May 15, 2026 */
<template lang="pug">
	div(style="margin-top:20px;font-size:15px;")
		details
			summary(class="primary") <strong> Custom Fields</strong>
			div(class="form-group")
				hr
				div(class="form-group grid-container")
					div(v-for ="cf in d_customFields" style="width:520px;")
						label(v-if="cf.type !== 'checkbox'" style="margin-bottom: 0rem;" :class="m_required(cf.name)?'required-label':''") {{cf.label}}
						div(v-if="['oppr','proj','acct','extr','cmpt','team'].includes(cf.type)")
							kt-select(:p_appEntKey="cf.type" :p_currentVal="d_recData[cf.name]" :p_readOnly="m_readOnly(cf.name)" :p_enableCreate="false"
							@change="m_entityChange($event,cf)"  )
						div(v-else-if="cf.type=='percent'" class="form-group grid-item" style="width:504px;padding-right:8%;")
							label(:class="m_required(cf.name)?'required-label':''") {{cf.label}}
							b-input-group(size="sm" append="%")
								b-form-input(class="styled-input"  :id="cf.name"  :value="d_recData[cf.name]"   @change="m_dataChange(cf)")
						div(v-else-if="cf.type=='time'" class="form-group"  )
							b-form-timepicker(class="styled-input" :id="cf.name" v_model="d_recData[cf.name]"  :value="d_recData[cf.name]" locale="en" @input="m_inputTime($event,cf)")
						div(v-else-if="cf.type=='url'" class="form-group"  )
							b-form-input(class="styled-input" :id="cf.name" type="text" v_model="d_recData[cf.name]"  @change="m_dataChange(cf)")
						div(v-else-if="cf.type=='checkbox'" class="form-group grid-item"  style="margin-top:35px;")
							b-form-checkbox(:id="cf.name" size="sm" type="checkbox" v-model="d_recData[cf.name]"  :value="Y" unchecked-value="N" @change="m_dataChange(cf)") {{cf.label}}						
						div(v-else-if="cf.type=='money'" class="form-group grid-item" )
							b-input-group(size="sm" prepend="$")
								b-form-input(class="styled-input"  :id="cf.name"  :value="d_recData[cf.name]?Number(d_recData[cf.name]).toLocaleString():''"   @change="m_dataChange(cf)")
						div(v-else-if="cf.multiSelect" class="form-group grid-item"  style="height:30px;width:504px;padding-right:8%;")
							kt-custom-multiselect(:id="cf.name" size="sm" :p_readOnly="m_readOnly(cf.name)" :p_options="m_selectOptions(cf)" :p_value="d_recData[cf.name]" @input="m_multiSelectInput($event,cf)")
						div(v-else-if="cf.listOfValues" class="form-group grid-item"  )
							b-form-select(class="styled-input" :id="cf.name" size="sm" :value="d_recData[cf.name]" :options="m_selectOptions(cf)"  @change="m_dataChange(cf)")
						div(v-else-if="cf.type=='tel'" class="form-group")
							kt-com-fld(:p_mode="p_mode" :id="cf.name" size="sm" typ="p" :value="d_recData[cf.name]" v_model="d_recData[cf.name]"  @input="m_comFieldInput($event,cf)")
						div(v-else class="form-group grid-item")
							b-form-input(class="styled-input" :id="cf.name" size="sm" :type="cf.type" :value="d_recData[cf.name]" v_model="d_recData[cf.name]"  @change="m_dataChange(cf)")
</template>
<script>
import util, {kbdpAlert} from "@/utils/util.js";
import {refData,userSettings} from "@/utils/ref-data.js";
import {fn_simpleSearch,settings as api} from "@/utils/api.js";
import KTcustomMultiSelect from "@/components/Ctrl/KT-CustomMultiSelect.vue";
export default {
	name: "kt-custom-field",
	components: {
			"kt-custom-multiselect":KTcustomMultiSelect
	},
	created() {if(this.p_recData) this.d_recData=this.p_recData;
			let params = {
				context: 'allRecords',
				query: null,
				filter: null,
				};
				
				var allOptions=[];
				this.d_customFields.forEach(cf=>{
					if(cf.listOfValues) allOptions=[...allOptions,...cf.listOfValues];
					});
					
				const entOptions=['opportunities','accounts','projects','contacts','competitors','team'];
				var commonOptions=allOptions.filter(v => entOptions.includes(v.toLowerCase()));
				if(commonOptions.length>0){
					fn_simpleSearch(params).then(resp => {
						resp.searchResult.forEach(s=>{
						this.d_optionValues.push({recType:s.recType,value:s.recNo,text:s.recName});
								});
					});
				}
				
		var usrOpts = userSettings.userOptions;
		this.d_readOnlyColumns=usrOpts['tableReadOnlyColumns']['kt-table-'+this.p_prntRecKey];
		if(!this.d_readOnlyColumns) this.d_readOnlyColumns=[];
		this.d_requiredColumns=usrOpts['tableRequiredColumns']['kt-table-'+this.p_prntRecKey];
		if(!this.d_requiredColumns) this.d_requiredColumns=[];
		this.d_requiredFields=this.d_requiredColumns.map(c=>{return c.field;});
	
	},
	mounted() {
				this.d_readOnlyColumns.forEach(col=>{if(document.getElementById(col)) document.getElementById(col).disabled=true;});
				this.d_requiredColumns.forEach(col=>{if(document.getElementById(col)) document.getElementById(col).required=true;});	
	},
	data() {
		return {
			d_recData:{},
			d_customFields:refData.customFields.filter(c=>(c.context==this.p_prntRecKey)),
			d_optionValues:[],
			d_readOnlyColumns:[],
			d_requiredColumns:[],
			d_requiredFields:[],
		};
	},
	props: {
		p_recData: Object,
		p_prntRecKey: String,
		p_style:String,
		p_mode:String,
	},
	computed: {
			c_tblStyle() {
			return this.p_style?this.p_style:"display:block;flex: 0 0 50%;";
			},
			c_selectOptions(cf){return this.m_selectOptions(cf);}
	},
	methods: {
		m_entityChange(e,cf){
				var map=new Map([['oppr','opportunity'],
								['proj','project'],
								['acct','account'],
								['extr','externalContact'],
								['cmpt','competitor'],
								['team','teamMember']
								]);
				var entityId=map.get(cf.type)+'Id';
				var entityNo=map.get(cf.type)+'No';
				var entityName=map.get(cf.type)+'Name';
				this.d_recData[cf.name]={type:cf.type, id:e[entityId], no:e[entityNo],name:e[entityName], profPic: cf.type=='team'};
				this.$emit('change',this.d_recData);
		},
		m_dataChange(cf){
				if(cf.type=='checkbox')
					this.d_recData[cf.name]=document.getElementById(cf.name).checked?'Y':'N'
				else 
				if(cf.type=='money'){
					var moneyVal=document.getElementById(cf.name).value.split(',').join('');
					this.d_recData[cf.name]=moneyVal;
					}
				else
					this.d_recData[cf.name]=document.getElementById(cf.name).value;
					this.$emit('change',this.d_recData);
				},
		m_comFieldInput(e,cf){
			this.d_recData[cf.name]=e;
			},
		m_selectOptions(cf){
						var map=new Map([['opportunities','oppr'],
										['projects','proj'],
										['accounts','acct'],
										['contacts','extr'],
										['competitors','cmpt'],
										['team','team']
										]);
					if(cf.listOfValues[0]){
						var LOV=cf.listOfValues[0].toLowerCase();
						if(map.has(LOV))
							return this.d_optionValues.filter(v=>(v.recType==map.get(LOV)));
						else return cf.listOfValues;
						}
				},
		m_inputTime(e,cf){
			this.d_recData[cf.name]=e;
			this.$emit('change',this.d_recData);
		},
		m_multiSelectInput(e,cf){
			//this.d_recData[cf.name]=JSON.stringify(e);
			this.d_recData[cf.name]=e;
			this.$emit('change',this.d_recData);
		},
		m_readOnly(col){return (this.d_readOnlyColumns&&this.d_readOnlyColumns.includes(col))?true:false;},
		m_required(col){return (this.d_requiredFields&&this.d_requiredFields.includes(col))?true:false;},
	},
	watch: {
	p_recData(nv,ov){
			this.d_recData=nv;
			this.d_customFields.forEach(cf=>{
					console.log(cf.name);
					if(cf.type=='checkbox' &&
						this.d_recData[cf.name]=='Y'){
							document.getElementById(cf.name).checked = true;
							}
					});
			},
	p_mode(nv) {
			if(nv == 'create' || nv=='edit'){
				//- Read Only Columns.
				this.d_readOnlyColumns.forEach(col=>{if(document.getElementById(col)) document.getElementById(col).disabled=true;});
			}
		},
	
	}
};
</script>
<style lang="less">
hr{border: 0.1px solid;}
.grid-container {
  display: grid;
  grid-template-columns: auto auto;
}
.grid-item {
  border: none; 
  font-size: 15px;
  text-align: left;
}
fieldset {
-webkit-border-radius: 8px;
-moz-border-radius: 8px;
border-radius: 8px;
}
summary {list-style: none}
summary::-webkit-details-marker {display: none; }
details summary::before { 
  content:"🡒"; 
  color: #1E90FF; 
  /* you can style it however you want, use background-image for example */
}

/* By using [open] we can define different styles when the disclosure widget is open */
details[open] summary::before { 
  content:"🠣";  /*"🡑"*/ 
  color: #1E90FF; 
}
.primary{color:#007bff;}
.styled-input,
.styled-select {
  width: 100%;
  border: 0px;
  border-radius: 0px;
  border-bottom: 1px solid #ddd;  //1px solid black;
}
.styled-input:disabled,
.styled-select:disabled {
  background-color: transparent;
  border-bottom: 1px solid #ddd;
}
.styled-input:focus,
.styled-select:focus {
  border-color: transparent;
  border-bottom: 1px solid #428bca;    //1px solid #428bca;
  box-shadow: none;
}
</style>